<template>
  <button
    :type="type"
    class="ui-icon-button"
    :class="[
      customClass,
      {
        'ui-icon-button--icon-only': iconOnly,
        'ui-icon-button--active': active,
        'ui-icon-button--disabled': disabled,
      },
    ]"
    :disabled="disabled"
    :title="title"
    :aria-label="resolvedAriaLabel"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="icon" aria-hidden="true"></i>
    <span v-if="label && !iconOnly" class="ui-icon-button__label">{{ label }}</span>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    title: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    resolvedAriaLabel() {
      return this.ariaLabel || this.title || this.label || undefined;
    },
  },
};
</script>

<style src="../styles/IconButton.css"></style>
